const getters = {
    equipments: (state) => state.equipments,
    documents: (state) => state.documents,
    file: state => state.file,
    loading: state => state.loading,
    docLoader: state => state.docLoader
};

export default getters;